import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface SportBadgeProps {
  sport: 'soccer' | 'csgo';
  className?: string;
}

const SportBadge = ({ sport, className }: SportBadgeProps) => {
  const getSportConfig = (sport: string) => {
    switch (sport) {
      case 'soccer':
        return {
          label: '⚽ Soccer',
          variant: 'secondary' as const,
          className: 'bg-green-100 text-green-800 hover:bg-green-200'
        };
      case 'csgo':
        return {
          label: '🎯 CS:GO',
          variant: 'secondary' as const,
          className: 'bg-orange-100 text-orange-800 hover:bg-orange-200'
        };
      default:
        return {
          label: sport,
          variant: 'secondary' as const,
          className: ''
        };
    }
  };

  const config = getSportConfig(sport);

  return (
    <Badge 
      variant={config.variant}
      className={cn(config.className, className)}
    >
      {config.label}
    </Badge>
  );
};

export default SportBadge;